export default function SlackLogo() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      aria-hidden='true'
    >
      <path
        fill='#36C5F0'
        d='M9 0a2 2 0 0 0 0 4h2V2a2 2 0 0 0-2-2ZM2 6a2 2 0 0 0 0 4h7a2 2 0 0 0 0-4H2Z'
      />
      <path
        fill='#2EB67D'
        d='M24 9a2 2 0 0 0-4 0v2h2a2 2 0 0 0 2-2ZM18 2a2 2 0 0 0-4 0v7a2 2 0 0 0 4 0V2Z'
      />
      <path
        fill='#ECB22E'
        d='M15 24a2 2 0 0 0 0-4h-2v2a2 2 0 0 0 2 2ZM22 18a2 2 0 0 0 0-4h-7a2 2 0 0 0 0 4h7Z'
      />
      <path
        fill='#E01E5A'
        d='M0 15a2 2 0 0 0 4 0v-2H2a2 2 0 0 0-2 2ZM6 22a2 2 0 0 0 4 0v-7a2 2 0 0 0-4 0v7Z'
      />
    </svg>
  );
}
